/**
 * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
 * images to fit into a certain area.
 */
export function calculateAspectRatioFit(srcWidth: number, srcHeight: number, maxWidth: number, maxHeight: number): { width: number; height: number } {
    const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth * ratio, height: srcHeight * ratio };
}

export async function convertFileToBase64(file: File | Blob): Promise<string | ArrayBuffer | null | undefined> {
    return new Promise<string | ArrayBuffer | null | undefined>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
export async function getImageSize(file: File | Blob): Promise<{ width: number, height: number }> {
    return new Promise<{ width: number, height: number }>((resolve, reject) => {

        const reader = new FileReader();

        //Read the contents of Image File.
        reader.readAsDataURL(file);
        reader.onload = e => {

            //Initiate the JavaScript Image object.
            const image = new Image();
            if (!e || !e.target || !e.target.result) return reject('getImageSize - invalid file');

            //Set the Base64 string return from FileReader as source.
            image.src = e.target.result as string;

            //Validate the File Height and Width.
            image.onload = () => {
                const height = image.height;
                const width = image.width;
                resolve({ width, height });
                return true;
            };
        };
    });
}


export async function checkIfImageExists(src: string): Promise<boolean> {
    return new Promise(resolve => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);

        img.src = src;
    });
}

export async function getBase64Image(imgUrl: string): Promise<string> {
    return new Promise(resolve => {

        const img = new Image();

        img.onload = function () {

            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL('image/jpeg');

            resolve(dataURL); // the base64 string

        };

        // set attributes and src
        img.setAttribute('crossOrigin', 'anonymous'); //
        img.src = imgUrl;
    });
}